import { render, staticRenderFns } from "./NavBarCompany.vue?vue&type=template&id=35ecaac6&"
import script from "./NavBarCompany.vue?vue&type=script&lang=js&"
export * from "./NavBarCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomePageNavbar: require('/workspace/components/HomePage/HomePageNavbar.vue').default,LoginForm: require('/workspace/components/Login/LoginForm.vue').default})
